
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.499 12c0 5-7.498 8.5-7.498 8.5S2.499 17 2.499 12V5.5l7.502-4 7.498 4V12z","fill":"#4BB44B","fill-opacity":".3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.002.934l.235.125 7.498 4L18 5.2v.3h-.5.5V12c0 2.746-2.044 5-3.937 6.516a21.525 21.525 0 01-3.825 2.425l-.018.009-.005.002h-.001v.001L10 20.5l-.211.453h-.002l-.005-.003-.018-.009a20.49 20.49 0 01-1.185-.633 21.522 21.522 0 01-2.642-1.792C4.045 17 2 14.746 2 12V5.501h.5H2v-.3l.265-.142 7.501-4 .236-.125zM3 5.8V12c0 2.255 1.706 4.25 3.563 5.735a20.528 20.528 0 003.438 2.208l.094-.048a20.529 20.529 0 003.343-2.16C15.294 16.25 17 14.255 17 12V5.8l-6.999-3.733L3 5.8zm7.002 14.7l-.212.453.212.099.21-.099-.21-.453z","fill":"#4BB44B"}})])
          )
        }
      }
    